import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';

export default function SignUpPage() {
  const [searchParams] = useSearchParams();
  const selectedPlan = searchParams.get('plan');
  
  // Pass the selected plan to user details via URL parameter
  const fallbackRedirectUrl = selectedPlan ? `/user-details?plan=${selectedPlan}` : '/user-details';
  
  return (
    <div className="flex justify-center items-center h-screen">
      <SignUp
        path="/sign-up"
        routing="path"
        signInUrl="/sign-in"
        fallbackRedirectUrl={fallbackRedirectUrl}
      />
    </div>
  );
}
